//* Libraries imports
import { ArrowLeft, Info } from "lucide-react";

//* Hooks Imports
import { useNavigate } from "react-router-dom";

type PaymentInnerHeaderProps = {
  onBack?: () => void;
  title?: string;
};

export function PaymentInnerHeader({
  onBack,
  title,
}: PaymentInnerHeaderProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <header className="w-full flex items-center justify-between px-4 py-4 bg-white/80 backdrop-blur-sm sticky top-0 z-10 border-b border-transparent">
      <button
        onClick={handleBack}
        className="size-10 flex items-center justify-center rounded-lg bg-clarobg-202 border border-clarobordas-01 hover:bg-gray-100 transition-colors"
      >
        <ArrowLeft size={20} className="text-claroprimaria-01" />
      </button>

      {title && (
        <h1 className="text-lg font-semibold text-clarotexto-201 absolute left-1/2 -translate-x-1/2">
          {title}
        </h1>
      )}

      <div className="size-10 flex items-center justify-center rounded-lg bg-clarobg-202 border border-clarobordas-01">
        <Info size={20} className="text-clarotexto-201" />
      </div>
    </header>
  );
}
